import request from '@/utils/request'
import { v2Host } from '@/config/host'

// mindwork 作品接口
// http://playable.dev.com:8067/?doc=website/creative.go

export function creatCase(data) {
  return request({
    url: `${v2Host}/website/creative/create`,
    method: 'post',
    data: data
  })
}

export function deleteCase(id, data) {
  return request({
    url: `${v2Host}/website/creative/delete?id=${id}`,
    method: 'post',
    data: data
  })
}

// 发布作品
export function publishCase(id, data) {
  return request({
    url: `${v2Host}/website/creative/publish?id=${id}`,
    method: 'post',
    data: data
  })
}

export function updateCreative(id, data) {
  return request({
    url: `${v2Host}/website/creative/update?id=${id}`,
    method: 'post',
    data: data
  })
}

export function fetchCreativeList(params) {
  return request({
    url: `${v2Host}/website/creative/list`,
    method: 'get',
    params: params
  })
}

export function fetchCaseInfo(params) {
  return request({
    url: `${v2Host}/website/creative/info?id=${params.id}`,
    method: 'get',
    params: params
  })
}

export function fetchPosterList(params) {
  return request({
    url: `${v2Host}/website/publisher/search-list`,
    method: 'get',
    params: params
  })
}

